<template>
    <div class="exchange-prize-area" :style="areaStyle">
        <template v-if="showList">
            <template v-for="(item, index) in prizeList">
                <Prize v-if="item.name === 'prize'"
                    :key="index" :index="index" :info="item" :pageDetail="pageDetail"
                    @emitEvent="receiveEvent"
                    />
            </template>
        </template>

        <template v-if="showViewPrize"> <!-- 查看奖品组件 -->
            <ViewPrize :info="viewPrizeInfo" @emitEvent="receiveEvent" />
        </template>

        <template v-if="showExchangePrize"> <!-- 兑换奖品组件 -->
            <ExchangePrize :info="exchangePrizeInfo" @emitEvent="receiveEvent" />
        </template>

        <template v-if="showExchangePrizeFailure"> <!-- 兑换奖品失败 -->
            <ExchangePrizeFailure :info="exchangePrizeFailureInfo" @emitEvent="receiveEvent" />
        </template>

        <template v-if="showViewVirtual"> <!-- 展示虚拟奖品 -->
            <ViewVirtual :info="viewVirtualInfo" @emitEvent="receiveEvent" />
        </template>

        <template v-if="showAddAddress"> <!-- 展示添加收货地址 -->
            <AddAddress :info="addAddressInfo" @emitEvent="receiveEvent" />
        </template>

        <template v-if="showViewNotice"> <!-- 展示告知型奖品 -->
            <ViewNotice :info="viewNoticeInfo" @emitEvent="receiveEvent" />
        </template>

        <template v-if="showEditAddress"> <!-- 展示编辑收货地址 -->
            <EditAddress :info="editAddressInfo" @emitEvent="receiveEvent" />
        </template>

    </div>
</template>

<script>

import {
    Prize,
    ViewPrize,
    ExchangePrize,
    ExchangePrizeFailure,
    ViewVirtual,
    AddAddress,
    EditAddress,
    ViewNotice
} from './components'

export default {

    name: 'ExchangePrizeArea',

    components: {

        Prize,

        ViewPrize,

        ExchangePrize,

        ExchangePrizeFailure,

        ViewVirtual,

        AddAddress,

        ViewNotice,

        EditAddress,

    },

    props: {

        info: { // 内容
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        },

        pageDetail: { // 活动数据
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        },

        receiveData: { // 接收数据
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        }

    },

    watch: {

        pageDetail: {
            handler(val) {
                if (val) {
                    this.showList = false
                    this.$nextTick(() => {
                        this.initPrizeList()
                    })
                }
            },
            deep: true
        },

        receiveData: { // 接收数据
            handler(val) {
                this.dispatchEvent(val)
            },
            deep: true
        },

    },

    data() {

        return {

            areaStyle: {},

            prizeList: [],

            showList: false,

            showViewPrize: false,

            viewPrizeInfo: {},

            showExchangePrize: false,

            exchangePrizeInfo: {},

            showExchangePrizeFailure: false,

            exchangePrizeFailureInfo: {},

            showViewVirtual: false,

            viewVirtualInfo: {},

            showAddAddress: false,

            addAddressInfo: {},

            showViewNotice: false,

            viewNoticeInfo: {},

            showEditAddress: false,

            editAddressInfo: {},
        }

    },

    mounted() {

        this.init()

        if (this.receiveData) {
            this.dispatchEvent(this.receiveData)
        }

    },

    methods: {

        init() {

            this.initPrizeList()

            this.dynamicStyle()

        },

        initPrizeList() {

            let list = this.info.list

            let $list = this.pageDetail.exchangePrizeList

            if ($list) {
                list.forEach((item) => {
                    $list.forEach(($item) => {
                        if (item && item.prizeConfig && item.prizeConfig.baseConfig && item.prizeConfig.baseConfig.prizeId) {
                            let columnNo = item.prizeConfig.baseConfig.columnNo

                            if ($item.column === columnNo) {
                                item = Object.assign(item, {
                                    $$opts: $item
                                })
                            }
                        }

                    })
                })
                this.showList = true
            }

            this.prizeList = list

        },

        dynamicStyle() {

            let val = this.info

            if (val.baseConfig) {
                let backHeight = window.screen.availWidth/(val.baseConfig.img.width/val.baseConfig.img.height)
                let height = {
                    height: `${backHeight}px`
                }
                let background = {
                    backgroundImage: `url(${val.baseConfig.img.url})`,
                    backgroundSize: `100% ${backHeight}px`,
                    backgroundPosition: '0px 0px',
                }
                this.areaStyle = {
                    ...height,
                    ...background
                }
            }

        },

        viewPrize(data, options) { // 查看奖品
            let { index = 0 } = data
            this.viewPrizeInfo = this.prizeList[index]
            this.showViewPrize = true
        },

        closeViewPrize() { // 关闭查看奖品
            this.viewPrizeInfo = {}
            this.showViewPrize = false
        },

        exchangePrizeEvent(data, options) { // 兑换奖品
            let { index = 0 } = data
            this.exchangePrizeInfo = this.prizeList[index]
            this.showExchangePrize = true
        },

        submitExchangePrize(data, options) { // 提交兑换奖品
            this.$emit('emitEvent', {
                type: 'exchangePrizeEvent',
                data: data,
                options: options
            })
        },

        closeExchangePrize() { // 关闭兑换奖品弹窗
            this.exchangePrizeInfo = {}
            this.showExchangePrize = false
        },

        exchangePrizeResponse(res, options) { // 兑换奖品响应的结果
            if (res && res.success) {
                const { model } = res
                if (model.exchangeResult) {
                    this.processExchangePrizeSuccess(model, options)
                } else {
                    this.processExchangePrizeFailure(model)
                }
            } else {
                this.toast('当前网络不佳，请稍后重试~')
            }
        },

        processExchangePrizeSuccess(model, options) { // 处理兑换奖品成功
            const { exchangePrizeId, prizeType, id } = model
            let info = {
                recordId: id
            }
            info = Object.assign(info, model)
            let list = this.prizeList
            list.forEach(item => {
                if (item && item.$$opts && item.$$opts.prizeId == exchangePrizeId) {
                    info = Object.assign(info, item.prizePopup)
                }
            })
            switch (prizeType) {
                case 1: // 虚拟奖品
                    this.showViewVirtual = true
                    this.viewVirtualInfo = info
                    break;
                case 2: // 实物奖品
                    this.showAddAddress = true
                    this.addAddressInfo = info
                    break;
                case 3: // 告知奖品
                    this.showViewNotice = true
                    this.viewNoticeInfo = info
                    break;
            }
        },

        processExchangePrizeFailure(model) { // 处理兑换奖品失败
            let { errorCode, errorMessage } = model
            // if (errorCode && ['PRIZE_INVENTORY_ERROR', 'AMOUNT_THRESHOLD_ERROR'].indexOf(errorCode) !== -1) {
            //     this.showExchangePrizeFailure = true
            //     let mapping = {
            //         'PRIZE_INVENTORY_ERROR': 'stock',
            //         'AMOUNT_THRESHOLD_ERROR': 'payment'
            //     }
            //     this.exchangePrizeFailureInfo = this.info.errorConfig && this.info.errorConfig[mapping[errorCode]]
            // } else {
            this.toast(errorMessage)
            // }
        },

        closeExchangePrizeFailure() { // 关闭兑换奖品出现错误
            this.showExchangePrizeFailure = false
            this.exchangePrizeFailureInfo = {}
        },

        submitAddress(data, options) { // 提交地址信息 新增和编辑都走这个函数
            this.$emit('emitEvent', {
                type: 'submitAddressEvent',
                data: data,
                options: options
            })
        },

        submitAddressResponse(res, options) { // 提交地址信息的结果
            if (res && res.success) {
                this.toast('提交成功')
            } else {
                this.toast(res.errorMessage || '')
            }
        },

        viewVirtualTrigger(data, options) { // 查看虚拟奖品
            let { exchangePrizeId } = data
            let info = data
            let list = this.prizeList
            list.forEach(item => {
                if (item && item.$$opts && item.$$opts.prizeId == exchangePrizeId) {
                    info = Object.assign(info, item.prizePopup)
                }
            })
            this.showViewVirtual = true
            this.viewVirtualInfo = info
        },

        addAddressTrigger(data, options) { // 添加地址
            let { exchangePrizeId, id } = data
            let info = {
                recordId: id
            }
            info = Object.assign(info, data)
            let list = this.prizeList
            list.forEach(item => {
                if (item && item.$$opts && item.$$opts.prizeId == exchangePrizeId) {
                    info = Object.assign(info, item.prizePopup)
                }
            })
            this.showAddAddress = true
            this.addAddressInfo = info
        },

        viewNoticeTrigger(data, options) { // 查看虚拟奖品
            let { exchangePrizeId } = data
            let info = data
            let list = this.prizeList
            list.forEach(item => {
                if (item && item.$$opts && item.$$opts.prizeId == exchangePrizeId) {
                    info = Object.assign(info, item.prizePopup)
                }
            })
            this.showViewNotice = true
            this.viewNoticeInfo = info
        },

        editAddressTrigger(data, options) { // 编辑地址
            let { exchangePrizeId, id } = data
            let info = {
                recordId: id,
                $model: options
            }
            info = Object.assign(info, data)
            let list = this.prizeList
            list.forEach(item => {
                if (item && item.$$opts && item.$$opts.prizeId == exchangePrizeId) {
                    info = Object.assign(info, item.prizePopup)
                }
            })

            this.showEditAddress = true
            this.editAddressInfo = info
        },


        closeViewVirtual() { // 关闭查看 虚拟奖品
            this.showViewVirtual = false
            this.viewVirtualInfo = {}
        },

        closeAddAddress() { // 关闭添加地址
            this.showAddAddress = false
            this.addAddressInfo = {}
        },

        closeViewNotice() { // 关闭查看 告知奖品
            this.showViewNotice = false
            this.viewNoticeInfo = {}
        },

        closeEditAddress() { // 关闭编辑地址
            this.showEditAddress = false
            this.editAddressInfo = {}
        },

        toast(txt, duration) { // 封装统一的信息处理函数
            this.$toast({
                styles: {
                    maskColor: "rgba(0,0,0,0)",
                    background: "rgba(0,0,0,0.4)",
                    messageColor: "#fff"
                },
                content: txt,
                duration: duration || 2000
            })
        },

        receiveEvent(e) { // 接收子组件的事件
            let {
                type,
                data,
                options
            } = JSON.parse(JSON.stringify(e))
            this[type] && this[type](data, options)
        },

        dispatchEvent(e) { // 分发来自父级的事件
            const {
                type,
                data,
                options
            } = JSON.parse(JSON.stringify(e))
            this.$nextTick(() => {
                this[type] && this[type](data, options)
            })
        },



    },

}
</script>

<style lang="scss" scoped>
.exchange-prize-area {
    width: 100%;
    position: relative;
}

</style>
